import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Chip, Typography } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-premium";
import cloneDeep from 'lodash';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DynamicCatalogBuilder } from "../../../../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { MuiStack } from "../../../../../../../components";
import { DesktopTabComponent } from "../../../../../../../components/molecules/desktopTabComponent";
import { ESystemName, LOCAL_STORAGE_KEYS } from "../../../../../../../constants";
import { useAppSelector } from "../../../../../../../store/hooks";
import { secondaryTextGray } from "../../../../../../../theme/palette";
import { getLocalStorageItem } from "../../../../../../../utils/storageHelper";
import { dateFormate } from "../../../../../../../utils/utils";
import { DownloadIconSVG, EditIconSVG, PrintIconSVG, ShareOutlinedIconSVG } from "../../../../../purchaseRequistion/assets/customIcons";
import { InterWarehouseSTRFilter } from "../components/interWarehouseSTRFilter";
import { MoreDetails } from "../components/moreDetails/moreDetails";
import { interWarehouseGetPartListAPICall, interWarehouseRequisitionPagingAPICall } from "../services/apiCall";
import { EStocktransferTypes, InterWarehouseTransferRequisitionKeys, interWarehouseTransferRequisitionPagingAPI, viewTypeOptions } from "../services/entity";
import HeaderCatalogPageComponent from "../../../../../../../components/templates/headerCatalogPageUpdated";
var InterWarehouseRequisition = function () {
    var _crud$filterValue, _getLocalStorageItem, _getLocalStorageItem2, _crud$InterWarehouseT;
    var _a = useState('list'), activeView = _a[0], setActiveView = _a[1];
    var _b = useState(false), isFilterOpen = _b[0], setFilterOpen = _b[1];
    var _c = useState(), rowData = _c[0], setRowData = _c[1];
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var crud = useAppSelector(function (state) { return state.crud; });
    var filterValue = (_crud$filterValue = crud['filterValue']) === null || _crud$filterValue === void 0 ? void 0 : _crud$filterValue.data;
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE);
    var navigate = useNavigate();
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var onToggleViewChange = function (view) {
        setActiveView(view);
    };
    var _d = useState(viewTypeOptions.length > 0 && isAllViewActive ? viewTypeOptions[0] : viewTypeOptions[1]), selectedListVariant = _d[0], setSelectedListVariant = _d[1];
    var getIcon = function (name) {
        switch (name) {
            case 'Edit':
                return /*#__PURE__*/ React.createElement(EditIconSVG, {
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'Print':
                return /*#__PURE__*/ React.createElement(PrintIconSVG, {
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'DownloadPDF':
                return /*#__PURE__*/ React.createElement(DownloadIconSVG, {
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'Share':
                return /*#__PURE__*/ React.createElement(ShareOutlinedIconSVG, {
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            default:
                return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
    };
    var handleClickFilterIcon = function () {
        setFilterOpen(function (prev) { return !prev; });
    };
    var getRequest = function () {
        var _filterValue$Status, _getLocalStorageItem3;
        var request = {
            FromDate: filterValue !== null && filterValue !== void 0 && filterValue.FromDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.FromDate : "",
            Type: EStocktransferTypes.WToWRequisition,
            SourceTenantId: UserOrganization,
            SourceParentTenantId: UserParentOrganization,
            ToDate: filterValue !== null && filterValue !== void 0 && filterValue.ToDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.ToDate : filterValue !== null && filterValue !== void 0 && filterValue.FromDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.FromDate : "",
            Status: filterValue === null || filterValue === void 0 || (_filterValue$Status = filterValue.Status) === null || _filterValue$Status === void 0 ? void 0 : _filterValue$Status.map(function (item) { return item === null || item === void 0 ? void 0 : item.Name; }),
            IdentityId: selectedListVariant === "My requisitions" ? (_getLocalStorageItem3 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem3 === void 0 || (_getLocalStorageItem3 = _getLocalStorageItem3.data) === null || _getLocalStorageItem3 === void 0 ? void 0 : _getLocalStorageItem3.IdentityId : undefined
        };
        if (filterValue !== null && filterValue !== void 0 && filterValue.Type) {
            request = _objectSpread(_objectSpread({}, request), {}, {
                Type: filterValue === null || filterValue === void 0 ? void 0 : filterValue.Type
            });
        }
        if (filterValue !== null && filterValue !== void 0 && filterValue.SourceTenantId) {
            request = _objectSpread(_objectSpread({}, request), {}, {
                SourceTenantId: filterValue === null || filterValue === void 0 ? void 0 : filterValue.SourceTenantId
            });
        }
        if (filterValue !== null && filterValue !== void 0 && filterValue.TransporterId) {
            request = _objectSpread(_objectSpread({}, request), {}, {
                TransporterId: filterValue === null || filterValue === void 0 ? void 0 : filterValue.TransporterId
            });
        }
        if (filterValue !== null && filterValue !== void 0 && filterValue.SourceParentTenantId) {
            request = _objectSpread(_objectSpread({}, request), {}, {
                SourceParentTenantId: filterValue === null || filterValue === void 0 ? void 0 : filterValue.SourceParentTenantId
            });
        }
        if (filterValue !== null && filterValue !== void 0 && filterValue.SourceWarehouseId) {
            request = _objectSpread(_objectSpread({}, request), {}, {
                SourceWarehouseId: filterValue === null || filterValue === void 0 ? void 0 : filterValue.SourceWarehouseId
            });
        }
        if (filterValue !== null && filterValue !== void 0 && filterValue.DestinationWarehouseId) {
            request = _objectSpread(_objectSpread({}, request), {}, {
                DestinationWarehouseId: filterValue === null || filterValue === void 0 ? void 0 : filterValue.DestinationWarehouseId
            });
        }
        return request;
    };
    useEffect(function () {
        interWarehouseRequisitionPagingAPICall({
            key: InterWarehouseTransferRequisitionKeys.Paging,
            request: getRequest(),
            url: interWarehouseTransferRequisitionPagingAPI
        });
    }, [selectedListVariant, filterValue]);
    var customActionColumns = [{
            field: 'SrNo',
            headerName: 'Sr No.',
            valueFormatter: function (val, row, col, api) { return api.current.getRowIndexRelativeToVisibleRows(row === null || row === void 0 ? void 0 : row.id) + 1; },
            minWidth: 100
        }, {
            field: 'DocumentCode',
            headerName: 'Document Number',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.DocumentCode ? "".concat(row === null || row === void 0 ? void 0 : row.DocumentCode) : '-'; },
            minWidth: 200
        }, {
            field: 'DocumentDate',
            headerName: 'Requisition Date',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.DocumentDate ? "".concat(dateFormate(row === null || row === void 0 ? void 0 : row.DocumentDate)) : '-'; },
            minWidth: 200
        }, {
            field: 'CreatedBy',
            headerName: 'Created By',
            align: 'center',
            valueFormatter: function (val, row) {
                var _row$RecordedByGivenN, _row$RecordedByFamily;
                return row !== null && row !== void 0 && row.RecordedByGivenName || row !== null && row !== void 0 && row.RecordedByFamilyName ? "".concat((_row$RecordedByGivenN = row === null || row === void 0 ? void 0 : row.RecordedByGivenName) !== null && _row$RecordedByGivenN !== void 0 ? _row$RecordedByGivenN : ' ', "  ").concat((_row$RecordedByFamily = row === null || row === void 0 ? void 0 : row.RecordedByFamilyName) !== null && _row$RecordedByFamily !== void 0 ? _row$RecordedByFamily : ' ') : '-';
            },
            minWidth: 200
        }, {
            field: 'CreatedOn',
            headerName: 'Created Date',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.CreatedOn ? "".concat(dateFormate(row === null || row === void 0 ? void 0 : row.CreatedOn)) : '-'; },
            minWidth: 200
        }, {
            field: 'SourceWarehouseName',
            headerName: 'Source warehouse',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.SourceWarehouseName ? "".concat(row === null || row === void 0 ? void 0 : row.SourceWarehouseName) : '-'; },
            minWidth: 200
        }, {
            field: 'DestinationWarehouse',
            headerName: 'Destination warehouse',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.SourceWarehouseName ? "".concat(row === null || row === void 0 ? void 0 : row.SourceWarehouseName) : '-'; },
            minWidth: 200
        }, {
            field: 'ExpectedTransferDate',
            headerName: 'Expected Transfer Date',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.ExpectedTransferDate ? "".concat(dateFormate(row === null || row === void 0 ? void 0 : row.ExpectedTransferDate)) : '-'; },
            minWidth: 200
        }, {
            field: 'StatusName',
            headerName: 'Status',
            renderCell: function (params) {
                var _params$row, _params$row$StatusNam, _params$row2, _params$row3;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    alignItems: 'center',
                    height: '100%'
                }, params !== null && params !== void 0 && (_params$row = params.row) !== null && _params$row !== void 0 && _params$row.StatusName ? /*#__PURE__*/ React.createElement(Chip, {
                    label: (_params$row$StatusNam = params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.StatusName) !== null && _params$row$StatusNam !== void 0 ? _params$row$StatusNam : '-',
                    size: "small",
                    variant: "outlined",
                    id: 'status',
                    sx: {
                        borderRadius: 2,
                        px: 1,
                        fontWeight: 500,
                        fontSize: 12,
                        color: 'black'
                    },
                    icon: (params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.StatusName) == 'Cancelled' ? /*#__PURE__*/ React.createElement(Box, {
                        height: 8,
                        width: 8,
                        borderRadius: 10,
                        bgcolor: "red"
                    }) : undefined
                }) : /*#__PURE__*/ React.createElement(Typography, null, '-'));
            },
            minWidth: 200
        }, {
            field: 'TotalAmount',
            headerName: 'Total Amount',
            valueFormatter: function (val, row) {
                var _Number;
                return val ? (_Number = Number(val)) === null || _Number === void 0 ? void 0 : _Number.toFixed(2) : '-';
            },
            minWidth: 200
        }, {
            type: 'actions',
            field: 'actions',
            headerName: '',
            getActions: function (params) {
                var _params$row4;
                var menuFeatures = cloneDeep(storedMenuFeatures);
                var list = menuFeatures === null || menuFeatures === void 0 ? void 0 : menuFeatures.filter(function (data) { return !(data.Name == 'Cancel' || data.Name == 'Edit'); });
                var data = (params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.StatusName) === 'Cancelled' ? list : storedMenuFeatures;
                return data === null || data === void 0 ? void 0 : data.map(function (data) { /*#__PURE__*/ return React.createElement(GridActionsCellItem, {
                    label: data === null || data === void 0 ? void 0 : data.DisplayName,
                    icon: getIcon(data === null || data === void 0 ? void 0 : data.Name),
                    divider: (data === null || data === void 0 ? void 0 : data.Name) === 'Edit',
                    id: "action-icon",
                    showInMenu: true,
                    onClick: function () {
                        if ((data === null || data === void 0 ? void 0 : data.Name) == 'Edit') {
                            var _params$row5;
                            handleRowEditClick(params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.id);
                        }
                    }
                }); });
            },
            minWidth: 50
        }];
    var handleRowEditClick = function (id) {
        interWarehouseGetPartListAPICall({
            request: {
                StockTransferRequisitionId: id
            }
        });
        navigate("./createInterWarehouseTransfer/".concat(id, "?mode=edit"));
    };
    var handleSelectMenu = function (listVariant) {
        setSelectedListVariant(listVariant);
    };
    var handleRowClick = function (row) {
        setRowData(row);
    };
    var handleDrawerClose = function () {
        setRowData(undefined);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, {
        items: viewTypeOptions
    }), /*#__PURE__*/ React.createElement(HeaderCatalogPageComponent, {
        handleClickFilterIcon: handleClickFilterIcon,
        selectedMenuItem: selectedListVariant,
        menus: viewTypeOptions.length > 0 ? viewTypeOptions : undefined,
        onSelectMenu: handleSelectMenu,
        activeView: activeView,
        onToggleView: onToggleViewChange,
        totalCount: (_crud$InterWarehouseT = crud[InterWarehouseTransferRequisitionKeys.Paging]) === null || _crud$InterWarehouseT === void 0 ? void 0 : _crud$InterWarehouseT.count,
        onClickCreateModule: function () {
            navigate('./createInterWarehouseTransfer?mode=add');
        },
        createButtonText: "New",
        isCreateButton: true,
        moduleName: ESystemName.InterWarehouseRequisition
    }), /*#__PURE__*/ React.createElement(Box, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: InterWarehouseTransferRequisitionKeys.Paging,
        getPagingData: interWarehouseRequisitionPagingAPICall,
        pagingAPIRequest: getRequest(),
        columns: customActionColumns,
        dataGridProps: {
            onCellClick: function (params) {
                if (!(params.field == 'actions')) {
                    handleRowClick(params.row);
                }
            },
            disableColumnMenu: false
        }
    })), /*#__PURE__*/ React.createElement(MoreDetails, {
        handleRowEditClick: handleRowEditClick,
        handleDrawerClose: handleDrawerClose,
        openDrawer: Boolean(rowData === null || rowData === void 0 ? void 0 : rowData.id),
        rowData: rowData,
        getPartsApiKey: InterWarehouseTransferRequisitionKeys.GetPartList
    }), /*#__PURE__*/ React.createElement(InterWarehouseSTRFilter, {
        isFilterOpen: isFilterOpen,
        setFilterOpen: handleClickFilterIcon
    }));
};
export default InterWarehouseRequisition;
